import React from 'react'
import type { ComponentProps } from 'react'
import styled from '@emotion/styled'
import type { RacePreviewTipsCard } from '@core/Areas/Racing/Components/RaceContent/RacePreviewTipsCard'
import racingSportsImage from './assets/Racing&SportIcon.png'
import { useRaceSportsContent } from './useRaceSportsContent'

type CardProps = Omit<
  ComponentProps<typeof RacePreviewTipsCard>,
  'raceKey' | 'isRaceOpen' | 'race' | 'tipSource'
>

export function useRaceSportsContentCardProps(
  meetingDate: Date,
  raceNumber: number,
  racecourseSeq?: number
): CardProps | null {
  const { isLoading, isError, content } = useRaceSportsContent(
    meetingDate,
    raceNumber,
    racecourseSeq
  )

  if (isLoading || isError || !content?.racePreview) {
    return null
  }

  return {
    title: 'Racing & Sports Tips',
    headerTrailContent: (
      <RacingSportsImageStyled src={racingSportsImage} alt="Picture of this meeting'\''s expert" />
    ),
    tips: content.racePreview.numbers ?? [],
    previewText: content.racePreview.previewText,
    panelTestId: 'racing-sport-panel',
    suggestedBet: content.racePreview.suggestedBet,
    containerTestId: 'racing-sport-content-panel',
  }
}

// ======
// Styles
// ======

const RacingSportsImageStyled = styled.img({
  height: '2.5rem',
  width: 'auto',
  backgroundColor: 'transparent',
  borderRadius: '50%',
})
